/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import { IconButton, InputAdornment, MenuItem, Select } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
// Material Dashboard 2 React example components
import TimelineItem from "examples/Timeline/TimelineItem";
import useDashboard from "hooks/useDashboard";
import { useEffect, useState } from "react";
import useCampaign from "hooks/useCampaign";
const formatDateIndian = (isoString) => {
  const date = new Date(isoString);
  return date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};
function OrdersOverview() {
  const { getActiveCampaign, activeCampaign } = useDashboard();
  const { getActiveCampaignOptions } = useCampaign();
  const [selectedOption, setSelectedOption] = useState("");
  const [allActiveCampaigns, setAllActiveCampaigns] = useState([]);
  const handleChange = (event) => {
    setSelectedOption(event.target.value);
    getActiveCampaign({ campaign: event.target.value });
  };
  useEffect(() => {
    getActiveCampaign();
    getActiveCampaignOptions().then((res) => {
      if (res.success) {
        setAllActiveCampaigns(res.data);
      }
    });
  }, []);
  return (
    <Card sx={{ height: "100%" }}>
      <MDBox pt={3} px={3}>
        <MDBox display="flex" alignItems="center" justifyContent="space-between">
          <MDTypography variant="h6" fontWeight="medium">
            Active Campaigns
          </MDTypography>
          <MDBox>
            <Select
              value={selectedOption}
              onChange={handleChange}
              fullWidth
              variant="outlined"
              sx={{ height: "45px" }}
              displayEmpty
              endAdornment={
                <InputAdornment position="end">
                  {selectedOption ? (
                    <IconButton
                      onClick={() => {
                        setSelectedOption("");
                        getActiveCampaign();
                      }}
                      edge="end"
                    >
                      <ClearIcon />
                    </IconButton>
                  ) : (
                    <UnfoldMoreIcon />
                  )}
                </InputAdornment>
              }
            >
              <MenuItem value="" disabled>
                Select a Campaign
              </MenuItem>
              {allActiveCampaigns.map((option) => (
                <MenuItem key={option._id} value={option._id}>
                  {option.name}
                </MenuItem>
              ))}
            </Select>
          </MDBox>
        </MDBox>
        {activeCampaign?.name ? (
          <MDBox mt={0} mb={2}>
            <MDTypography variant="button" color="text" fontWeight="regular">
              <MDTypography display="inline" variant="body2" verticalAlign="middle">
                {activeCampaign?.name}
              </MDTypography>
            </MDTypography>
            <br />
            <MDTypography variant="button" color="text" fontWeight="medium">
              Start Date: {formatDateIndian(activeCampaign?.startDate)} End Date:{" "}
              {formatDateIndian(activeCampaign?.endDate)}
            </MDTypography>
          </MDBox>
        ) : (
          <MDBox>
            <MDTypography mt="4rem">No Active campaign</MDTypography>
          </MDBox>
        )}
      </MDBox>
      <MDBox p={2}>
        {activeCampaign?.rewards?.map((reward, index) => (
          <TimelineItem
            key={index}
            color={["success", "error", "info", "warning", "primary"][index % 5]} // Rotating colors
            title={`${reward.position} - ₹${reward.value}`}
            dateTime={reward.description}
            lastItem={index === activeCampaign.rewards.length - 1}
          />
        ))}
      </MDBox>
    </Card>
  );
}

export default OrdersOverview;
